// extracted by mini-css-extract-plugin
export default {"button":"ZedJX8iAO14cHYsOvzay"};